import axios from 'axios';
import { httpClient } from '@/api/httpClient';
import { environment } from '@/config/environment';
import {
  mapApiResourceToHostWorkspace,
  type HostWorkspace,
  type HostWorkspaceApiResource,
} from './hostWorkspaceApi.types';

const HOST_WORKSPACE_PATH = '/public/host-workspace';
const NOT_FOUND_STATUS = 404;

function isNotFoundResponse(requestError: unknown): boolean {
  if (axios.isAxiosError(requestError) === false || requestError.response === undefined) {
    return false;
  }
  return requestError.response.status === NOT_FOUND_STATUS;
}

function isServedFromPlatformAddress(): boolean {
  if (environment.platformUrl === '') {
    return false;
  }
  try {
    return new URL(environment.platformUrl).origin === window.location.origin;
  } catch (invalidPlatformUrl) {
    void invalidPlatformUrl;
    return false;
  }
}

export async function fetchHostWorkspace(): Promise<HostWorkspace | null> {
  if (isServedFromPlatformAddress()) {
    return null;
  }
  try {
    const response = await httpClient.get<HostWorkspaceApiResource>(HOST_WORKSPACE_PATH);
    return mapApiResourceToHostWorkspace(response.data);
  } catch (requestError) {
    if (isNotFoundResponse(requestError)) {
      return null;
    }
    throw requestError;
  }
}
